import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import moment from 'moment';
import { useSelector } from 'react-redux';
import API_BASE_URL from '../config';
import './ServiciosStandByPage.css';
import './SharedLoading.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { jwtDecode } from 'jwt-decode';

const ServiciosStandByPage = () => {
  const token = useSelector((state) => state.auth.token);
  const [serviciosSTDBY, setServiciosSTDBY] = useState([]);
  const [serviciosPAUSE, setServiciosPAUSE] = useState([]);
  const [modalAsignarVisible, setModalAsignarVisible] = useState(false);
  const [colaboradores, setColaboradores] = useState([]);
  const [busquedaSiglas, setBusquedaSiglas] = useState('');
  const [servicioSeleccionado, setServicioSeleccionado] = useState(null);
  const [siglaMap, setSiglaMap] = useState({});
  const [loadingPage, setLoadingPage] = useState(true);
  const [asignando, setAsignando] = useState(false);
  const decoded = token ? jwtDecode(token) : null;
  const estacionUsuario = decoded?.estacion?.toUpperCase();

  const ESTADOS_SERVICIO = {
    LLEGADAS: {
      NACIONAL: ["ASIGNADO", "INICIADO", "EQUIPAJE", "STDBY", "CONCLUIDO", "NOSHOW"],
      INTERNACIONAL: ["ASIGNADO", "INICIADO", "STDBY", "MIGRACION", "EQUIPAJE", "ADUANA", "CONCLUIDO", "NOSHOW"],
    },
    SALIDAS: {
      NACIONAL: ["ASIGNADO", "INICIADO", "EQUIPAJE", "STDBY", "CONCLUIDO", "NOSHOW"],
      INTERNACIONAL: ["ASIGNADO", "INICIADO", "EQUIPAJE", "STDBY", "CONCLUIDO", "NOSHOW"],
    },
  };

  const fetchServicios = useCallback(async () => {
    try {
      const resSTDBY = await axios.get(`${API_BASE_URL}api/servicios/serviciosStatus?status=STDBY`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const resPAUSE = await axios.get(`${API_BASE_URL}api/servicios/serviciosStatus?status=PAUSE`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const norm = (s) => (s || '').trim().toUpperCase();
      const estacionToken = estacionUsuario ? norm(estacionUsuario) : null;
      const getEstacionServicio = (s) => norm(s?.estacion ?? s?.Estacion ?? s?.station ?? s?.stationCode);

      const dataSTDBY = Array.isArray(resSTDBY.data) ? resSTDBY.data : [];
      const dataPAUSE = Array.isArray(resPAUSE.data) ? resPAUSE.data : [];
      const filtradosSTDBY = estacionToken ? dataSTDBY.filter((s) => getEstacionServicio(s) === estacionToken) : dataSTDBY;
      const filtradosPAUSE = estacionToken ? dataPAUSE.filter((s) => getEstacionServicio(s) === estacionToken) : dataPAUSE;

      console.groupCollapsed('[ServiciosStandBy] Filtro estación');
      console.log('Estación usuario (token):', estacionToken);
      console.log('STDBY total:', dataSTDBY.length, 'filtrados:', filtradosSTDBY.length);
      console.log('PAUSE total:', dataPAUSE.length, 'filtrados:', filtradosPAUSE.length);
      console.groupEnd();

      setServiciosSTDBY(filtradosSTDBY);
      setServiciosPAUSE(filtradosPAUSE);

      // Construir mapa noColaborador → siglas (incluye los del tracking de STDBY)
      const todosServicios = [...filtradosSTDBY, ...filtradosPAUSE];
      const idsTracking = filtradosSTDBY.flatMap(s =>
        (s.tracking || [])
          .filter(t => t.changes?.noColaborador?.to === 0 && t.changes.noColaborador.from)
          .map(t => t.changes.noColaborador.from)
      );
      const idsUnicos = [...new Set([
        ...todosServicios.map(s => s.noColaborador).filter(id => id && id !== 0),
        ...idsTracking,
      ])];
      if (idsUnicos.length > 0) {
        try {
          const resOps = await axios.get(`${API_BASE_URL}api/operadores`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          const ops = Array.isArray(resOps.data) ? resOps.data : [];
          const mapa = {};
          ops.forEach(op => {
            if (idsUnicos.includes(op.noColaborador)) {
              mapa[op.noColaborador] = op.siglas;
            }
          });
          setSiglaMap(mapa);
        } catch (e) {
          console.warn('No se pudieron cargar las siglas de operadores', e);
        }
      }

      const ahora = moment();

      filtradosSTDBY.forEach((serv) => {
        const salida = moment(serv.horaVuelo);
        const minutosRestantes = salida.diff(ahora, 'minutes');
        if (
          serv.statusServicio === 'STDBY' &&
          (!serv.noColaborador || serv.noColaborador === 0) &&
          minutosRestantes <= 60
        ) {
          toast.warning(
            <div className="custom-toast-alert">
              <div className="toast-title">
                ⚠️ Servicio sin colaborador
              </div>
              <div className="toast-body">
                <strong>#{serv.noServicio}</strong> — {serv.nombrePax?.trim() || 'Pasajero sin nombre'}<br />
                Vuelo sale en <strong>{minutosRestantes} min</strong>
              </div>
              <div className="toast-action-row">
                <button
                  className="btn-asignar-toast"
                  onClick={async () => {
                    toast.dismiss();
                    setServicioSeleccionado(serv);
                    await obtenerColaboradores();
                    setModalAsignarVisible(true);
                  }}
                >
                  Reasignar ahora
                </button>
              </div>
            </div>,
            { autoClose: 10000 }
          );
        }
      });

      filtradosPAUSE.forEach((serv) => {
        const salida = moment(serv.horaVuelo);
        const minutosRestantes = salida.diff(ahora, 'minutes');
        if (minutosRestantes <= 60) {
          toast.warning(
            <div className="custom-toast-alert">
              <div className="toast-title">
                ⏸ Servicio en PAUSE
              </div>
              <div className="toast-body">
                <strong>#{serv.noServicio}</strong> — {serv.nombrePax?.trim() || 'Pasajero sin nombre'}<br />
                Vuelo sale en <strong>{minutosRestantes} min</strong> · Estado: <span className="toast-status">PAUSE</span>
              </div>
            </div>,
            { autoClose: 8000 }
          );
        }
      });
    } catch (err) {
      console.error('Error al obtener servicios STDBY y PAUSE:', err);
    } finally {
      setLoadingPage(false);
    }
  }, [token]);

  useEffect(() => {
    fetchServicios();
    const interval = setInterval(fetchServicios, 60000);
    return () => clearInterval(interval);
  }, [fetchServicios]);

  const obtenerEstados = (tipo, intNac) => {
    const t = tipo?.toUpperCase();
    const n = intNac?.toUpperCase();
    return ESTADOS_SERVICIO[t]?.[n] || [];
  };

  const obtenerColaboradores = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}api/bitacora/en-turno-detalles`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const colaboradoresFiltrados = res.data.filter(
        (colab) => colab.estacion?.trim().toUpperCase() === estacionUsuario
      );
      const colaboradoresUnicos = colaboradoresFiltrados.filter(
        (colab, index, self) =>
          index === self.findIndex((c) => c.noColaborador === colab.noColaborador)
      );
      setColaboradores(colaboradoresUnicos);
    } catch (error) {
      console.error("❌ Error al obtener colaboradores:", error);
      toast.error("Error al cargar colaboradores disponibles");
    }
  };

  const asignarServicio = async (colaborador) => {
    if (!servicioSeleccionado) return;
    if (asignando) return;
    setAsignando(true);
    try {
      await axios.put(`${API_BASE_URL}api/servicios/${servicioSeleccionado._id}`, {
        noColaborador: colaborador.noColaborador,
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success(`Servicio asignado a ${colaborador.siglas}`);
      setModalAsignarVisible(false);
      setServicioSeleccionado(null);
      fetchServicios();
    } catch (error) {
      console.error('❌ Error al asignar servicio:', error);
      toast.error('Error al asignar servicio');
    } finally {
      setAsignando(false);
    }
  };

  const obtenerClaseUrgencia = (horaVuelo) => {
    if (!horaVuelo) return '';
    const ahora = moment();
    const salida = moment(horaVuelo);
    const diffMinutos = salida.diff(ahora, 'minutes');
    if (diffMinutos <= 60) return 'urgente-rojo';
    if (diffMinutos <= 90) return 'urgente-amarillo';
    return 'urgente-verde';
  };

  const tieneConexion = (conexion) =>
    conexion && conexion.trim() !== '' && conexion.trim() !== '-';

  // Extrae el último noColaborador antes de pasar a STDBY (tracking: noColaborador.to === 0)
  const getLastColaborador = (servicio) => {
    if (!Array.isArray(servicio.tracking) || servicio.tracking.length === 0) return null;
    const entradas = servicio.tracking
      .filter(t => t.changes?.noColaborador?.to === 0 && t.changes.noColaborador.from)
      .sort((a, b) => new Date(b.at) - new Date(a.at));
    return entradas.length > 0 ? entradas[0].changes.noColaborador.from : null;
  };

  const getIcon = (etapa) => {
    switch (etapa) {
      case 'ASIGNADO': return <i className='fa fa-user' />;
      case 'INICIADO': return <i className="fa fa-play" />;
      case 'STDBY': return <i className="fa fa-pause-circle" />;
      case 'MIGRACION': return <i className="fa fa-passport" />;
      case 'EQUIPAJE': return <i className="fa fa-suitcase" />;
      case 'ADUANA': return <i className="fa fa-search-dollar" />;
      case 'CONCLUIDO': return <i className="fa fa-check-circle" />;
      case 'NOSHOW': return <i className="fa fa-user-slash" />;
      case 'ABORDAJE': return <i className="fa fa-plane-departure" />;
      case 'FINALIZADO': return <i className="fa fa-check" />;
      default: return etapa;
    }
  };

  const ServiceCard = ({ servicio, tipo }) => {
    const etapas = obtenerEstados(servicio.tipoService, servicio.int_nac);
    const currentIndex = etapas.indexOf(servicio.statusServicio?.toUpperCase());
    const urgencia = obtenerClaseUrgencia(servicio.horaVuelo);
    const conConexion = tieneConexion(servicio.conexion);

    return (
      <div className={`sb-card ${urgencia} sb-card-${tipo.toLowerCase()}`}>
        {/* Header */}
        <div className="sb-card-header">
          <div className="sb-header-left">
            <span className={`sb-tipo-badge ${servicio.tipoService === 'LLEGADAS' ? 'badge-llegada' : 'badge-salida'}`}>
              {servicio.tipoService === 'LLEGADAS' ? '↓ LLE' : '↑ SAL'}
            </span>
            <span className="sb-aerolinea">{servicio.aerolinea} {servicio.noVuelo}</span>
          </div>
          <span className="sb-no-servicio">#{servicio.noServicio}</span>
        </div>

        {/* Ruta */}
        <div className="sb-ruta">
          <span>{servicio.origenVuelo}</span>
          <span className="sb-ruta-arrow">→</span>
          <span>{servicio.destinoVuelo}</span>
        </div>

        {/* Progress bar */}
        <div className="sb-progress-bar">
          {etapas.map((etapa, idx) => (
            <React.Fragment key={etapa}>
              <div className={`sb-circle ${idx <= currentIndex ? 'active' : ''}`} title={etapa}>
                {getIcon(etapa)}
              </div>
              {idx < etapas.length - 1 && (
                <div className={`sb-line ${idx < currentIndex ? 'active' : ''}`} />
              )}
            </React.Fragment>
          ))}
        </div>

        {/* Info grid */}
        <div className="sb-info-grid">
          <div className="sb-info-item">
            <span className="sb-info-label">PAX</span>
            <span className="sb-info-value">{servicio.nombrePax || 'N/A'}</span>
          </div>
          <div className="sb-info-item">
            <span className="sb-info-label">Hora vuelo</span>
            <span className="sb-info-value">{moment(servicio.horaVuelo).format('HH:mm')}</span>
          </div>
          <div className="sb-info-item">
            <span className="sb-info-label">Ubicación</span>
            <span className="sb-info-value">{servicio.checkpoint || 'Sin especificar'}</span>
          </div>
          <div className="sb-info-item">
            <span className="sb-info-label">Colaborador</span>
            <span className="sb-info-value">
              {servicio.noColaborador && servicio.noColaborador !== 0 ? (
                <span className="colaborador-tag">
                  {siglaMap[servicio.noColaborador]
                    ? `${siglaMap[servicio.noColaborador]} — #${servicio.noColaborador}`
                    : `#${servicio.noColaborador}`}
                </span>
              ) : (() => {
                const lastId = getLastColaborador(servicio);
                return lastId ? (
                  <span className="colaborador-tag colaborador-ultimo">
                    {siglaMap[lastId]
                      ? `${siglaMap[lastId]} — #${lastId}`
                      : `#${lastId}`}
                    <span className="ultimo-label">último</span>
                  </span>
                ) : (
                  <span className="sin-asignar">Sin asignar</span>
                );
              })()}
            </span>
          </div>
          <div className="sb-info-item sb-info-full">
            <span className="sb-info-label">Conexión</span>
            <span className={`sb-conexion ${conConexion ? 'conexion-si' : 'conexion-no'}`}>
              <span className="conexion-dot" />
              {conConexion ? servicio.conexion : 'Sin conexión'}
            </span>
          </div>
        </div>

        {/* Acción */}
        {tipo === 'STDBY' && (
          <button
            className="sb-btn-reasignar"
            disabled={servicio.noColaborador && servicio.noColaborador !== 0}
            onClick={async () => {
              setServicioSeleccionado(servicio);
              await obtenerColaboradores();
              setModalAsignarVisible(true);
            }}
          >
            Reasignar
          </button>
        )}
      </div>
    );
  };

  const totalServicios = serviciosSTDBY.length + serviciosPAUSE.length;

  if (loadingPage) {
    return (
      <div className="sb-container">
        <div className="page-loading-overlay">
          <div className="page-loading-spinner" />
          <p className="page-loading-text">Cargando servicios en espera...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="sb-container">
      <ToastContainer
        position="top-right"
        autoClose={8000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
        newestOnTop
      />

      {/* Page header */}
      <div className="sb-page-header">
        <div className="sb-page-title-group">
          <h1 className="sb-page-title">Servicios en Espera</h1>
          <span className="sb-page-subtitle">STDBY y PAUSE</span>
        </div>
        <div className="sb-totales">
          <div className="sb-total-chip sb-total-stdby">
            <span className="sb-total-num">{serviciosSTDBY.length}</span>
            <span className="sb-total-label">STDBY</span>
          </div>
          <div className="sb-total-chip sb-total-pause">
            <span className="sb-total-num">{serviciosPAUSE.length}</span>
            <span className="sb-total-label">PAUSE</span>
          </div>
          <div className="sb-total-chip sb-total-general">
            <span className="sb-total-num">{totalServicios}</span>
            <span className="sb-total-label">Total</span>
          </div>
        </div>
      </div>

      {/* Columnas */}
      <div className="sb-dual-column">
        {/* STDBY */}
        <div className="sb-columna">
          <div className="sb-col-header sb-col-header-stdby">
            <i className="fa fa-pause-circle" />
            <span>STDBY</span>
            <span className="sb-col-count">{serviciosSTDBY.length}</span>
          </div>
          {serviciosSTDBY.length === 0 ? (
            <div className="sb-empty">
              <i className="fa fa-check-circle" />
              <p>Sin servicios en STDBY</p>
            </div>
          ) : (
            serviciosSTDBY.map((servicio) => (
              <ServiceCard key={servicio.noServicio} servicio={servicio} tipo="STDBY" />
            ))
          )}
        </div>

        {/* PAUSE */}
        <div className="sb-columna">
          <div className="sb-col-header sb-col-header-pause">
            <i className="fa fa-clock" />
            <span>PAUSE</span>
            <span className="sb-col-count">{serviciosPAUSE.length}</span>
          </div>
          {serviciosPAUSE.length === 0 ? (
            <div className="sb-empty">
              <i className="fa fa-check-circle" />
              <p>Sin servicios en PAUSE</p>
            </div>
          ) : (
            serviciosPAUSE.map((servicio) => (
              <ServiceCard key={servicio.noServicio} servicio={servicio} tipo="PAUSE" />
            ))
          )}
        </div>
      </div>

      {/* Modal asignar */}
      {modalAsignarVisible && (
        <div className="sb-modal-overlay" onClick={() => setModalAsignarVisible(false)}>
          <div className="sb-modal" onClick={(e) => e.stopPropagation()}>
            <div className="sb-modal-header">
              <div>
                <h3 className="sb-modal-title">Asignar Colaborador</h3>
                <p className="sb-modal-sub">Servicio #{servicioSeleccionado?.noServicio} — {servicioSeleccionado?.nombrePax}</p>
              </div>
              <button className="sb-modal-close" onClick={() => setModalAsignarVisible(false)}>✕</button>
            </div>
            <input
              type="text"
              placeholder="Buscar por siglas..."
              className="sb-search"
              value={busquedaSiglas}
              onChange={(e) => setBusquedaSiglas(e.target.value.toUpperCase())}
            />
            <div className="sb-colab-list">
              {colaboradores
                .filter(c => c.siglas.toUpperCase().includes(busquedaSiglas))
                .map((colab) => (
                  <div key={colab.noColaborador} className="sb-colab-row">
                    <div className="sb-colab-info">
                      <span className="sb-colab-siglas">{colab.siglas}</span>
                      <span className="sb-colab-nombre">{colab.nombreCompleto}</span>
                      <span className="sb-colab-estacion">{colab.estacion}</span>
                    </div>
                    <button
                      className="sb-btn-seleccionar"
                      onClick={() => asignarServicio(colab)}
                      disabled={asignando}
                    >
                      Seleccionar
                    </button>
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServiciosStandByPage;
